<mat-form-field>
	<mat-label>{{ label }}</mat-label>
	<input
		matInput
		[placeholder]="placeholder"
		[formControl]="formControl"
		(blur)="emitChanges()"
		(keydown.enter)="submitKeydown($event)"
	/>
</mat-form-field>
